import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import styled from "styled-components";
import Checkout from "./components/Checkout";
import Success from "./components/Success";
import * as yup from "yup";
import { useFormik } from "formik";
import axios from "axios";
import pagarme from "pagarme/browser";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import PollingStatus from "./components/PollingStatus";
import Failed from "./components/Failed";

const ButtonClose = styled.div`
  background: #41c78f;
  display: inline-block;
  padding: 10px 17px;
  position: absolute;
  top: -15px;
  right: -15px;
  color: #fff;
  font-weight: bold;
  border-radius: 50px;
  z-index: 9999;
  :hover {
    cursor: pointer;
    background: #3ab380;
  }
`;

const ResponsiveModal = styled(Modal)`
  .modal-body {
    padding: 40px !important;
    overflow-x: hidden;
    overflow-y: scroll;
  }

  .modal-content {
    border-radius: 10px !important;
    min-height: 80vh;
  }

  .modal-dialog {
    max-width: 700px !important;
  }

  @media screen and (max-width: 767px) {
    .modal-content {
      width: 90% !important;
      margin: 0 auto !important;
    }
  }
`;

export default function ModalSubscriptionPolling(props) {
  const [failedReason, setFailedReason] = useState({ message: "", details: "" });
  const [screen, setScreen] = useState("checkout");
  const authToken = useSelector(state => state.auth.authToken);
  const [pollingStatus, setPollingStatus] = useState(null);
  const [subStatus, setSubStatus] = useState(null);
  const modalInfo = useSelector(state => state.app.modal_subscription_polling);
  const clientSubscription = useSelector(
    state => state.app.client_subscription
  );

  const dispatch = useDispatch();
  const formik = useFormik({
    initialValues: {
      plan_id: null,
      cardholder_name: "",
      card_number: "",
      card_payment_method: null,
      card_cvv: "",
      card_expiration: "",
      card_selected: null
    },
    onSubmit: (values, { setSubmitting }) => {
      const pollingSubscription = async subscription_id => {
        if (clientSubscription?.external_id) return;

        const MAX_POLLING_TIME = 300 * 1000; // 5 minutos
        const startTime = Date.now();

        setPollingStatus("processing");

        const getPollingInterval = elapsedTimeInSeconds => {
          if (elapsedTimeInSeconds <= 60) {
            return 5000; // 5 segundos
          } else if (elapsedTimeInSeconds <= 120) {
            return 10000; // 10 segundos
          } else {
            // restante do tempo (3-5 minutos)
            return 20000; // 20 segundos
          }
        };

        while (Date.now() - startTime < MAX_POLLING_TIME) {
          try {
            const { data: subscription } = await axios.get(
              `${process.env.REACT_APP_API_URL}/subscription/polling/${subscription_id}`,
              {
                headers: {
                  Authorization: `Bearer ${authToken}`
                }
              }
            );
            
            if (subscription.reason?.message) {
              setFailedReason(subscription.reason);
            }

            if (subscription.status === "failed") {
              setSubStatus("failed");
              setScreen("failed");
              return true;
            }

            if (subscription.status === "trialing") {
              setSubStatus("trailSuccess");
              setTimeout(() => {
                setScreen("success");
              }, 1000);
              return true;
            }

            if (subscription.status === "active") {
              setSubStatus("activeSuccess");
              setTimeout(() => {
                setScreen("success");
              }, 1000);
              return true;
            }

            const elapsedTimeInSeconds = Math.floor(
              (Date.now() - startTime) / 1000
            );
            const pollingInterval = getPollingInterval(elapsedTimeInSeconds);
            const nextCheckInSeconds = pollingInterval / 1000;

            setPollingStatus(subscription.status);

            let message = `Assinatura com status ${subscription.status}. 
                Será verificado novamente em ${nextCheckInSeconds} segundos. Tempo total: ${elapsedTimeInSeconds} segundos`;

            console.log(message);

            await new Promise(resolve => setTimeout(resolve, pollingInterval));
          } catch (error) {
            console.error("ERROR pollingSubscription", JSON.stringify(error));
            setPollingStatus("failed");
            return false;
          }
        }

        console.log("Numero maximo de tentativas de polling atingido");
        setPollingStatus("timeout");
        return false;
      };

      if (values.card_selected === null) {
        var card = {};
        card.card_holder_name = values.cardholder_name;
        card.card_expiration_date =
          values.card_expiration.substr(0, 2) +
          "/" +
          values.card_expiration.substr(values.card_expiration.length - 2);
        card.card_number = values.card_number;
        card.card_cvv = values.card_cvv;
        var cardValidations = pagarme.validate({ card: card });

        if (!cardValidations.card.card_holder_name) {
          setSubmitting(false);
          toast.error("Verifique o nome impresso no cartão.");
          return false;
        }
        if (!cardValidations.card.card_number) {
          setSubmitting(false);
          toast.error("Verifique o número do cartão.");
          return false;
        }
        if (!cardValidations.card.card_expiration_date) {
          setSubmitting(false);
          toast.error("Verifique a data de expiração do cartão.");
          return false;
        }
        if (!cardValidations.card.card_cvv) {
          setSubmitting(false);
          toast.error("Verifique o código de segurança (CVV) do cartão.");
          return false;
        }
        if (clientSubscription.info.provider === "pagarme_v5") {
          //Fluxo V5 com cartão novo
          const options = {
            method: "POST",
            headers: {
              accept: "application/json",
              "content-type": "application/json"
            },
            body: JSON.stringify({
              type: "card",
              card: {
                number: card.card_number.replace(/\s/g, ""),
                holder_name: card.card_holder_name,
                exp_month: parseInt(card.card_expiration_date.substr(0, 2), 10),
                exp_year: parseInt(card.card_expiration_date.substr(3, 2), 10),
                cvv: card.card_cvv
              }
            })
          };
          fetch(
            `https://api.pagar.me/core/v5/tokens?appId=${process.env.REACT_APP_PAGARME_V5_ENCRYPTION_KEY}`,
            options
          )
            .then(response => {
              if (!response.ok) {
                throw new Error("Erro ao gerar token do cartão.");
              }
              return response.json();
            })
            .then(data =>
              dispatch({
                type: "CREATE_SUBSCRIPTION",
                payload: {
                  values: {
                    ...values,
                    card_hash: data.id,
                    client_id: modalInfo.client_id
                  },
                  callback: response => {
                    if (response.success && response.data.id) {
                      setScreen("polling");
                      pollingSubscription(response.data.id);
                    } else {
                      setPollingStatus("failed");
                      toast.error(
                        "Não foi possível iniciar o monitoramento da assinatura."
                      );
                    }
                  },
                  setSubmitting
                }
              })
            )
            .catch(() => {
              setSubmitting(false);
              toast.error(
                "Falha ao adicionar cartão. Por favor, tente novamente."
              );
            })
            .finally(() => setSubmitting(false));
        } else {
          //Fluxo V4 com cartão novo
          pagarme.client
            .connect({
              encryption_key: process.env.REACT_APP_PAGARME_ENCRYPTION_KEY
            })
            .then(client => client.security.encrypt(card))
            .then(card_hash => {
              dispatch({
                type: "CREATE_SUBSCRIPTION",
                payload: {
                  values: {
                    ...values,
                    card_hash: card_hash,
                    client_id: modalInfo.client_id
                  },
                  callback: response => {
                    if (response.success && response.data.id) {
                      setScreen("polling");
                      pollingSubscription(response.data.id);
                    } else {
                      setPollingStatus("failed");
                      toast.error(
                        "Não foi possível iniciar o monitoramento da assinatura."
                      );
                    }
                  },
                  setSubmitting
                }
              });
            });
        }
      } else {
        //Fluxo V4 e V5 com cartão já cadastrado
        dispatch({
          type: "CREATE_SUBSCRIPTION",
          payload: {
            values: {
              ...values,
              client_id: modalInfo.client_id,
              card_hash: values.card_selected?.hash ?? undefined,
              previous_subscription_id: modalInfo.migrationData?.currentSubscriptionId,
              migrationFlow: modalInfo.migrationData?.enableOrganicMigration && modalInfo.migrationData?.currentProvider === "pagarme"
            },
            callback: response => {
              if (response.data.payment_method === "boleto") {
                setSubStatus("boletoPending");  
                setTimeout(() => {
                  setScreen("success");
                }, 1000);
                return;
              }
              if (response.success && response.data.id) {
                setScreen("polling");
                pollingSubscription(response.data.id);
              } else {
                setPollingStatus("failed");
                toast.error(
                  "Não foi possível iniciar o monitoramento da assinatura."
                );
              }
            },
            setSubmitting
          }
        });
      }
    },
    validationSchema: yup.object().shape({
      plan_id: yup
        .object()
        .nullable()
        .required("Escolha o plano!"),
      cardholder_name: yup.string().when("card_selected", {
        is: null,
        then: yup
          .string()
          .required("O nome do titular do cartão é obrigatório.")
      }),
      card_number: yup.string().when("card_selected", {
        is: null,
        then: yup
          .string()
          .required("O número do cartão é obrigatório.")
          .test("isValidCardNumber", "Número do cartão inválido.", function(
            value
          ) {
            return value && value.length === 19;
          })
      }),
      card_expiration: yup.string().when("card_selected", {
        is: null,
        then: yup
          .string()
          .required("O mês/ano de expiração do cartão é obrigatório.")
          .test("isValidExpiration", "O vencimento é inválido.", function(
            value
          ) {
            return value && /^(0[1-9]|1[012]) [/] \d{2}/.test(value);
          })
      }),
      card_cvv: yup.string().when("card_selected", {
        is: null,
        then: yup
          .string()
          .required("O código de segurança (CVV) do cartão é obrigatório.")
          .test("isValidCVV", "Número do CVV inválido.", function(value) {
            return value && /^[0-9]{3,4}$/.test(value);
          })
      })
    })
  });

  const closeModal = () => {
    if (screen === "checkout") {
      dispatch({ type: "CLOSE_MODAL_SUBSCRIPTION_POLLING" });
      return;
    }
    setScreen("checkout");
    modalInfo.callback();
    dispatch({ type: "CLOSE_MODAL_SUBSCRIPTION_POLLING" });
  };

  return (
    <ResponsiveModal
      show={modalInfo.visible}
      onHide={closeModal}
      centered
      backdrop="static"
      keyboard={false}
    >
      <ButtonClose onClick={closeModal}>X</ButtonClose>

      <Modal.Body>
        {screen === "checkout" && (
          <Checkout
            screen={screen}
            setScreen={setScreen}
            formik={formik}
            migrationData={modalInfo.migrationData}
          />
        )}
        {screen === "polling" && <PollingStatus status={pollingStatus} />}
        {screen === "success" && (
          <Success screen={screen} setScreen={setScreen} close={closeModal} status={subStatus} />
        )}
        {screen === "failed" && <Failed onClose={closeModal} title={failedReason.message} subTitle={failedReason.details} />}
      </Modal.Body>
    </ResponsiveModal>
  );
}
